import { useCallback, useEffect } from "react"
import { useAppDispatch } from "@/store/index"
import { setIsDesktop, setScreen } from "@/store/slices/app"

export const useIsDesktop = () => {
  const dispatch = useAppDispatch()

  const handleSize = useCallback(() => {
    dispatch(setIsDesktop(window.innerWidth > 1100))
    dispatch(
      setScreen({ width: window.innerWidth, height: window.innerHeight })
    )
  }, [])

  useEffect(() => {
    handleSize()

    window.addEventListener("resize", handleSize)

    return () => {
      window.removeEventListener("resize", handleSize)
    }
  }, [handleSize])
}
